export const SPACE_SLUG = process.env.NEXT_PUBLIC_INTERACTIFY_SPACE_SLUG
export const INTERACTIFY_PARAM_KEY = 'vid'
export const INTERACTIFY_OPEN_SOURCD = 'vsrc'
export const INTERACTIFY_GALLERY_OPEN_SOURCE = 'gallery'

export const FETCH_NEXT_PAGE_THRESHOLD = 2
